// WHICH BUNDLES TAKE THE MYRA LIFT. Edit this file, not the gate.
//
// `subjectPrefixes` matches scene.json's own `subject`, so a new iteration of a
// listed checkpoint needs no edit. `characters` pins by slug, for a bundle whose
// subject does not name its checkpoint — the slug is what the URL says, so it is
// the one key that cannot be wrong about which character is on screen.
//
// Anything not listed here keeps the shared GpuLifter: isaac, eyeline, and every
// character added later. See
// ~/comments/aos-threejs-poc/myraLiftGate_chooseLift_subject_rule.py

export const MYRA_LIFT_CONFIG = {
  /** scene.json `subject`, matched case-insensitively as a PREFIX. */
  subjectPrefixes: ["myra"],
  /** Character slugs (`?character=`), matched exactly. */
  characters: ["rig"],
} as const;
